@let isExternal = isExternalIdentity();

<app-pan-card [isPageContainer]="true" [header]="'User Settings'">
  <div rightActions>
    <app-pan-button color="primary" (click)="save()">Save</app-pan-button>
  </div>

  <section class="mt-4">
    <app-pan-section-header [title]="'Name'"></app-pan-section-header>

    <div class="flex gap-2">
      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>First Name</app-pan-floating-label>
        <input panInput [(ngModel)]="givenName" [disabled]="isExternalIdentity()" />
      </app-pan-form-control>

      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>Last Name</app-pan-floating-label>
        <input panInput [(ngModel)]="familyName" [disabled]="isExternalIdentity()" />
      </app-pan-form-control>
    </div>

    @if (isExternal) {
      <div class="text-danger italic mt-3">* Your identity is managed by an external provider, and should be changed there.</div>
    }
  </section>

  @if (!isExternal && email()) {
    <section class="mt-4">
      <app-pan-section-header [title]="'Password'"></app-pan-section-header>

      <div class="mt-2">
        <app-pan-button color="warning" (click)="resetPassword()">Reset your password</app-pan-button>
      </div>
    </section>
  }

  <section class="mt-4">
    <app-pan-section-header [title]="'Email Preferences'"></app-pan-section-header>

    <div class="mt-2">
      <label>
        <input type="checkbox" panCheckbox [(ngModel)]="shouldReceiveTheftReportEmails" />
        Receive weekly incident report notifications
      </label>
    </div>

    <div class="mt-2" panRole [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager']">
      <label>
        <input type="checkbox" panCheckbox [(ngModel)]="shouldReceiveAccessRequests" />
        Receive requests for access to incident reports
      </label>
    </div>

    <div class="mt-2">
      <label>
        <input type="checkbox" panCheckbox [(ngModel)]="shouldReceiveMarketingEmails" />
        Receive marketing emails
      </label>
    </div>
  </section>
</app-pan-card>
